module.exports = __webpack_public_path__ + "img/auto-dialer.ca712d00.png";